<template>
  <el-dialog :visible.sync="eidtorVisible" :before-close="handlerClose" :show-close="false">
    <div slot="title" class="el-dialog__title">
      <div class="title-left"></div>
      <slot name="title">{{editorTitle}}</slot>
      <div class="title-right"></div>
    </div>
    <div class="content">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
        <el-form-item :label="$t('managementV2.name')+':'" prop="fullName"
                      v-if="editorType==='editorName'">
          <el-input v-model="ruleForm.fullName" size="small" @input="changInput('fullName')"
                    minlength='1' maxlength="50">
          </el-input>
        </el-form-item>
        <template v-else>
          <el-form-item :label="$t('team.class')+':'" prop="class">
            <el-input v-model="ruleForm.class" size="small" @input="changInput('class')"
                      minlength='1' maxlength="50"></el-input>
          </el-form-item>
          <el-form-item :label="$t('managementV2.major')+':'" prop="major">
            <el-select v-model="ruleForm.major"
                       :placeholder="$t('managementV2.pleaseselectaMajor')">
              <el-option v-for="(item,index) in majorList" :key="index" :label="item.value"
                         :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </template>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handlerClose" size="small">{{$t('managementV2.cancel')}}</el-button>
      <el-button type="primary" @click="determine" size="small">{{$t('managementV2.determine')}}
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
import { updateClass, updateClassUserName } from "@/services/managements"
export default {
  name: "editorDialog",
  data() {
    return {
      ruleForm: {
        fullName: "",
        class: "",
        major: "",
      },
      rules: {

      },
      majorList: [
        {
          value: "英语"
        },
        {
          value: "日语"
        },
        {
          value: "韩语"
        },
        {
          value: "俄语"
        }
      ],
      companyCode: JSON.parse(localStorage.getItem("userInfo")).selfCompany.code,
    }
  },
  props: {
    eidtorVisible: {
      type: Boolean,
      default: () => false,
    },
    editorTitle: {
      type: String,
      default: () => ""
    },
    editorType: {
      type: String,
      default: () => ""
    },
    editorId: {
      type: Number,
    },
    classInfo: {
      type: Object,
      default: () => { },
    },
  },
  watch: {
    classInfo: {
      handler(val) {
        this.ruleForm = {
          fullName: val.aliasName,
          class: val.name,
          major: val.major,
        }
      },
      deep: true
    }
  },
  methods: {
    changInput(type) {
      if (type === 'class') {
        this.ruleForm.class = this.ruleForm.class.replace(/^\s*/g, '');
      } else {
        this.ruleForm.fullName = this.ruleForm.fullName.replace(/^\s*/g, '');
      }
    },
    //关闭
    handlerClose() {
      this.ruleForm.fullName = this.classInfo.aliasName
      this.$emit("handlereditorClose")
    },
    //确定
    async determine() {
      if (this.editorType !== 'editorName') {
        if (this.ruleForm.class === '') {
          this.$message.closeAll();
          this.$message.warning(this.$t('managementV2.Classnamecannotbeempty'));
          return;
        }
        if (this.ruleForm.major === '') {
          this.$message.closeAll();
          this.$message.warning(this.$t('managementV2.Majorcannotbeempty'));
          return;
        }
        let params = {
          id: this.editorId,
          major: this.ruleForm.major,
          name: this.ruleForm.class,
          companyCode: this.companyCode
        }
        const { success } = await updateClass(params);
        if (success) {
          this.$message.success(this.$t('managementV2.Successfullymodifiedclassinformation'));
          this.$emit('handlereditorSuccess')
        }
      } else {
        let params = {
          id: this.editorId,
          name: this.ruleForm.fullName,
          companyCode: this.companyCode
        }
        const { success } = await updateClassUserName(params);
        if (success) {
          this.$message.success(this.$t('managementV2.Namemodifiedsuccessfully'));
          this.$emit('handlereditorSuccess')
        }
      }
    },

  }
}
</script>
<style lang="less" scoped>
/deep/.el-dialog {
  width: 553px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin-top: 0px !important;
  padding: 0 54px;
  box-sizing: border-box;
  border-radius: 12px 12px 12px 12px;
  .el-dialog__header {
    height: 58px;
    padding: 0px;
    border-bottom: 2px solid rgba(86, 96, 135, 0.1);
    .el-dialog__title {
      font-size: 18px;
      height: 18px;
      display: inline-block;
      line-height: 18px;
      font-weight: bold;
      color: #566087;
      margin-top: 17px;
      .title-left,
      .title-right {
        width: 6px;
        height: 18px;
        display: inline-block;
        vertical-align: top;
      }
      .title-left {
        margin-right: 9px;
        background: url("~@/components/layer/addUser/assets/images/popup_icon_Left.png")
          no-repeat center 5px;
      }
      .title-right {
        margin-left: 9px;
        background: url("~@/components/layer/addUser/assets/images/ppup_icon_right.png")
          no-repeat center 5px;
      }
    }
  }
  .el-dialog__body {
    padding: 10px 0px 0px 0px;
    // height: 32px;
    .el-form {
      .el-form-item {
        display: flex;
        margin-bottom: 15px;
        &:last-child {
          margin-bottom: 0px;
        }
      }
      .el-form-item__content {
        width: 375px;
        .el-select {
          width: 100%;
        }
      }
    }
  }
  .el-dialog__footer {
    padding: 30px 0px;
    display: flex;
    justify-content: center;
    .el-button {
      width: 76px;
    }
    .el-button + .el-button {
      margin-left: 20px;
    }
    .el-button--default {
      border: 1px solid #0078fc;
      color: #0078fc;
    }
  }
}
</style>